import apiRequest from './apiRequest';

const accountApi = {
    createAccount(data, token) {
        return apiRequest('/api/accounts', 'POST', token, data);
    },

    getAccount(id, token) {
        return apiRequest(`/api/accounts/${id}`, 'GET', token);
    },

    updateAccount(id, data, token) {
        return apiRequest(`/api/accounts/${id}`, 'PUT', token, data);
    },


    getAllAccounts(token, page = 0, size = 15) {
        const url = `/api/accounts?page=${page}&size=${size}`;
        return apiRequest(url, 'GET', token);
    },
    deleteAccount(id, token) {
        return apiRequest(`/api/accounts/${id}`, 'DELETE', token);
    },
    
    
     searchAccounts(searchTerm, token) {
        return apiRequest(`/api/accounts/search/${searchTerm}`, 'GET', token);
    },

    getAccountCount(token) {
        return apiRequest('/api/accounts/count', 'GET', token);
    },

    getTasksForAccount(accountId, token) {
        return apiRequest(`/api/accounts/${accountId}/tasks`, 'GET', token);
    },

// <====================Attachment API==========================================>
    uploadAttachment(accountId, formData, token) {
        return apiRequest(`/api/accounts/${accountId}/attachments`, 'POST', token, formData, true);
    },

    deleteAttachment(attachmentId, token) {
        return apiRequest(`/api/accounts/attachments/${attachmentId}`, 'DELETE', token);
    },
};

export default accountApi;
